import { appInsights } from '@services/appInsightsService';
import { SOURCE } from '@constants/commonConstants';
let navigateFunction;
export const setNavigateFunction = navigate => {
  navigateFunction = navigate;
};

export const navigateTo = route => {
  if (navigateFunction) {
    navigateFunction(route);
  } else {
    appInsights.trackTrace({
      message: JSON.stringify({
        message: 'Navigate function is not set',
        userId: localStorage.getItem('userEmail'),
        source: SOURCE.FRONTEND,
      }),
      severityLevel: 3, // 3 represents failure
    });
  }
};
